import { S3_FEED_URL } from '@constants/config';
import { parseRssFeed } from './episodeParser';
import { normalizeEpisodeFeed } from './episodeModel';

/**
 * Fetch and normalize the remote RSS feed.
 *
 * The fetch implementation is injectable so the model boundary can be tested
 * without a browser or network.
 */
export async function fetchEpisodeFeed({
  fetchImpl = globalThis.fetch,
  feedUrl = S3_FEED_URL,
  signal
} = {}) {
  if (typeof fetchImpl !== 'function') {
    throw new Error('Fetch is not available');
  }

  const response = await fetchImpl(feedUrl, { signal });

  if (!response.ok) {
    throw new Error(`Failed to fetch feed: ${response.status} ${response.statusText}`);
  }

  const xmlText = await response.text();
  return normalizeEpisodeFeed(parseRssFeed(xmlText));
}
